import {useEffect, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";

export const AdminsStudentsProfileFilterModal = (props: {
    active: boolean,
    closeHandler: any,
    onDone: any,
    current: 'all' | 'complete' | 'incomplete'
}) => {
    const [status, setStatus] = useState('all' as 'all' | 'complete' | 'incomplete');
    useEffect(() => {
        const isActive = props.active;
        const _current = props.current;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setStatus(_current);
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>وضعیت تکمیل اطلاعات</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label>نمایش دانش‌آموزان:</label>
                        <button className={"techaran-radio-box" + (status === 'all' ? ' active' : '')}
                                onClick={() => setStatus('all')}>
                            <div><i/></div>
                            <span>همه دانش‌آموزان</span>
                        </button>
                        <button className={"techaran-radio-box" + (status === 'complete' ? ' active' : '')}
                                onClick={() => setStatus('complete')}>
                            <div><i/></div>
                            <span>تکمیل اطلاعات شده</span>
                        </button>
                        <button className={"techaran-radio-box" + (status === 'incomplete' ? ' active' : '')}
                                onClick={() => setStatus('incomplete')}>
                            <div><i/></div>
                            <span>اطلاعات ناقص</span>
                        </button>
                        <div className="d-flex justify-content-end align-items-center"
                             style={{gap: 20, marginTop: 20}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={()=>{
                                const _current = status;
                                props.onDone(_current);
                                props.closeHandler();
                            }}>
                                <b>اعمال فیلتر</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};